
import Vue from 'vue';
import Modal from '~/components/builders/Base/Modal.vue';

export default Vue.extend({
    name: 'SchoolEventRegisteredModal',
    components: { Modal },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        schoolEvent: {
            type: Object,
            required: true,
        },
    },
    computed: {
        eventDates(): string {
            const startDate = this.schoolEvent.startTime;
            const endDate = this.schoolEvent.endTime;
            if (!startDate || !endDate) {
                return '';
            }

            let startYearFormat = 'numeric' as string | undefined;
            let startMonthFormat = 'long' as string | undefined;
            let startDayFormat = 'numeric' as string | undefined;
            let endYearFormat = 'numeric' as string | undefined;

            if (startDate.getFullYear() === endDate.getFullYear()) {
                startYearFormat = undefined;
                if (startDate.getMonth() === endDate.getMonth()) {
                    startMonthFormat = undefined;
                    if (startDate.getDate() === endDate.getDate()) {
                        startDayFormat = undefined;
                    }
                }
            }
            if (endDate.getFullYear() === new Date().getFullYear()) {
                endYearFormat = undefined;
            }

            const start =
                startYearFormat || startMonthFormat || startDayFormat
                    ? startDate.toLocaleDateString('en-GB', {
                          year: startYearFormat,
                          month: startMonthFormat,
                          day: startDayFormat,
                      }) + ' - '
                    : '';

            const end = endDate.toLocaleDateString('en-GB', {
                year: endYearFormat,
                month: 'long',
                day: 'numeric',
            });

            const startTime = startDate.toLocaleTimeString('en-GB', {
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: 'short',
            });
            return `${start}${end}, ${startTime}`;
        },
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        handleDeleteSignup() {
            this.$emit('delete-signup');
        },
        handleAddToCalendar() {
            this.$emit('add-to-calendar');
        },
    },
});
